import { type Package } from '@qdrant/qdrant-cloud-public-api/booking/v1';
import { type ClusterConfiguration } from '@/components/Clusters/ClusterSetup/ClusterConfiguration/ClusterConfigurationContext.types';
import { MIN_DISK_SPACE, MIN_NODES } from './constants';

export const toPackageResourcesObject = (bookingPackage?: Package | null) => ({
  get memory() {
    return bookingPackage?.resourceConfiguration?.ram;
  },
  get cpu() {
    return bookingPackage?.resourceConfiguration?.cpu;
  },
  get disk() {
    return bookingPackage?.resourceConfiguration?.disk;
  },
  get gpu() {
    return bookingPackage?.resourceConfiguration?.gpu;
  },
  getConfiguration(): ClusterConfiguration {
    return {
      additionalDisk: MIN_DISK_SPACE,
      cpu: parseInt(this.cpu ?? '0'),
      disk: parseInt(this.disk ?? '0'),
      gpu: parseInt(this.gpu ?? '0'),
      memory: parseInt(this.memory ?? '0'),
      nodes: MIN_NODES,
    };
  },
});
